export default function (accessor = value => value) {
    return {
        props: {
            value: {
                type: Object,
                required: true,
            },
        },
        computed: {
            journal() {
                return accessor(this.value).journal?.libelle;
            },
            telechargeable() {
                return !!accessor(this.value).lien;
            },
            tailleDocument() {
                return accessor(this.value).taille;
            },
            nomDocument() {
                return accessor(this.value).nom;
            },
            sousType() {
                return accessor(this.value).sousType;
            },
            dateDocument() {
                return accessor(this.value).date;
            },
            typeDocument() {
                return accessor(this.value).type;
            },
            destinataire() {
                return accessor(this.value).destinataire || null;
            },
            issuTeleservice() {
                return accessor(this.value).issuTeleservice || false;
            },
            typeFichier() {
                const mime = accessor(this.value).mime || "";
                if ("application/pdf" === mime) {
                    return "PDF";
                } else if (mime.startsWith("image/")) {
                    return "Image";
                }
                return null;
            },
        },
    };
}
